import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { remove } from 'lodash';

import { ClientDepartment, GetClientDepartmentsByStatusDocument } from 'api';

export default (cache: DataProxy, result: ExecutionResult) => {
  const { getClientDepartmentsByStatus } = cache.readQuery({
    query: GetClientDepartmentsByStatusDocument,
  });

  if (!getClientDepartmentsByStatus) {
    return;
  }

  getClientDepartmentsByStatus.count--;
  remove(getClientDepartmentsByStatus.client_departments, (item: ClientDepartment) => {
    const { updateClientDepartment } = result.data;
    return item.id === updateClientDepartment.id;
  });

  cache.writeQuery({
    query: GetClientDepartmentsByStatusDocument,
    data: {
      getClientDepartmentsByStatus,
    },
  });
};
